import { Environment } from '@abp/ng.core';

const baseUrl = window.location.origin;

export const environment = {
  production: true,
  hmr: false,
  application: {
    name: 'SestekAI',
    baseUrl,
  },
  oAuthConfig: {
    issuer: '/sestekai-auth',
    clientId: 'SestekAI_App',
    responseType: 'code',
    scope: 'offline_access SestekAI',
    skipIssuerCheck: true,
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: true,
    requireHttps: false,
    redirectUri: baseUrl,
    impersonation: {
      userImpersonation: true,
      tenantImpersonation: true,
    },
  },
  apis: {
    default: {
      url: '/sestekai-api',
      rootNamespace: 'SestekAI',
    },
  },
} as Environment;
